import { useContext, useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import PaymentFormList from "../../components/PaymentsFormList";
import { GlobalContext } from "../../contexts/global";
import { PaymentContext } from "../../contexts/payment";
import GetCardType from "../../helpers/creditCard";
import { BuyCoins } from "../../services/Api/payment";
import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import ConfirmCvv from "../Wallet/components/ConfirmCvv";
import Ticket from "./components/Ticket";

export default function PaymentCoin({ navigation, route }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const { selectedPaymentForm,
    newCard,
    validNewCard,
    saveCard,
    cardNumber,
    cardExpiration,
    cardBrand,
    cardName,
    saveCardApi,
    setCardNumber,
    setCardName, 
    setCardDocument, 
    setCardExpiration, 
    setCardCvv,
    setNewCard,
    clearInput } = useContext(PaymentContext);

  const [modalVisible, setModalVisible] = useState(false);
  const data = route.params;
  const paymentCoinApiHandler = (selectedCardData, cvv) => {
    setLoading({ show: true, message: "Realizando o pagamento" });

    BuyCoins(
      data.selectedCoinPrice.id,
      data.selectedCoinPrice.price,
      Encrypt(selectedCardData.cardNumber.replace(/\s/g, "")),
      cvv,
      selectedCardData.expiration,
      selectedCardData.idCard
    )
      .then((value) => {
        navigation.reset({ index: 0, routes: [{ name: "PaymentReceipt", params: value }] })
      })
      .catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: value.erro ? value.erro : value.message,
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        if(newCard){
          setCardNumber("")
          setCardName("") 
          setCardDocument("") 
          setCardExpiration("") 
          setCardCvv("") 
          setCardDocument("")
          setNewCard(false)
        }
        setLoading({ show: false, message: "Realizando o pagamento" });
      });
  };

  useEffect(() => {
    clearInput()
  }, [])
  
  const disabledButton =
    !!data.selectedCoinPrice && (!!selectedPaymentForm || newCard) ? false : true;

  return (
    <PageTitle title={"PAGAR CRÉDITOS"} navigation={navigation}>
      <KeyboardAwareScrollView
        style={{ flex: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        {data.selectedCoinPrice != null ? (
          <View
            style={{ flex: 1, justifyContent: "flex-start", width: "100%" }}
          >
            <Ticket creditInfo={data.selectedCoinPrice} />
            <View style={styles.viewSecundaria}>
              <View style={styles.titleBar}>
                <Text style={styles.titleText}>{"FORMAS DE PAGAMENTOS"}</Text>
              </View>
              <PaymentFormList totalAmount={data.selectedCoinPrice.price} hasWallets={false} />
              <IconButton
                textoBotao={"Realizar pagamento"}
                onPress={() => {
                  if (newCard) {
                    if (validNewCard()) {
                      if (saveCard) {
                        let cardBrandType = GetCardType(cardNumber.replace(/\s/g, ""));
                        setLoading({ show: true, message: "Salvando cartão" })
                        saveCardApi(cardBrandType)
                      }
                    }
                  }
                  setModalVisible(true);
                  setLoading({ show: false, message: "Salvando cartão" })
                }}
                iconName={"currency-usd"}
                estilo={{
                  backgroundColor: disabledButton
                    ? Colors.GRAY_DARK
                    : Colors.SUCCESS,
                  width: "100%",
                  marginTop: 16
                }}
                disabled={disabledButton}
              />
            </View>
            <ConfirmCvv
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              onPress={(cvv) => paymentCoinApiHandler(newCard ?
                {
                  brand: cardBrand,
                  expiration: cardExpiration,
                  cardNumber: cardNumber,
                  personName: cardName,
                }
                :
                selectedPaymentForm, cvv)}
              countCell={3}
            />
          </View>
        ) : (
          <></>
        )}
      </KeyboardAwareScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  titleText: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
  titleBar: {
    alignItems: "center",
    flexDirection: "row",
    padding: 12,
    justifyContent: "center",
  },
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
  },
});
